import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    style: { "position": "relative" },
    class: "pb-5 pt-5",
    "data-scroll-focus": "eventStaffFunctionCandidates",
    "data-test": "eventStaffFunctions"
};
const _hoisted_2 = {
    key: 0,
    "data-test": "eventStaffFunctionAlert"
};
const _hoisted_3 = { style: { "z-index": "1" } };
const _hoisted_4 = {
    key: 1,
    class: "d-flex flex-row pa-4 eventStaffFunctionInternalNote",
    "data-test": "eventStaffFunctionInternalNote"
};
const _hoisted_5 = { style: { "z-index": "1" } };
const _hoisted_6 = { class: "d-inline" };
const _hoisted_7 = { class: "edit btn-icon-with-text mr-0" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "text-end" };
const _hoisted_10 = { style: { "white-space": "nowrap" } };
const _hoisted_11 = { class: "mb-2" };
const _hoisted_12 = { class: "mb-2" };
const _hoisted_13 = {
    class: "text-end",
    style: { "vertical-align": "top" }
};
const _hoisted_14 = {
    key: 0,
    class: "mb-2"
};
import { ref, computed, shallowRef } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { cloneDeep } from "lodash-es";
import gql from "fraql";
import calculateCompetitionDays from "@/utils/competitionDays";
import { apolloClient } from "@/plugins/apollo/index.js";
import { useTranslation } from "i18next-vue";
import AppTableHeader from "@elements/table/AppTableHeader.vue";
import AppTable from "@elements/table/AppTable.vue";
import EventStaffFunctionForm from "./EventStaffFunctionForm.vue";
import { injectSnackbarError, injectAppFederation } from "@/composables/injections";
import { showLoadingButton } from "@/utils/showLoadingButton";
import AppButtonPositionSlot from "@elements/AppButtonPositionSlot.vue";
import AppConfirm from "@elements/AppConfirm.vue";
import EventStaffFunctionConfForm from "./EventStaffFunctionConfForm.vue";
import AppShowEventStaffFunctionConfStatusChip from "@AppShows/event/AppShowEventStaffFunctionConfStatusChip.vue";
import allowedMutation from "@/utils/allowedMutation";
import PersonEventStaffListDialog from "./PersonEventStaffListDialog.vue";
import { canManageEventStaffFunctionsConf } from "@/utils/canManageEventStaffFunctionsConf";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventStaffFunctions',
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const confirm = shallowRef();
        const { snackbarServerError } = injectSnackbarError();
        const { appFederation } = injectAppFederation();
        const functionForm = shallowRef();
        const functionConfigurationForm = shallowRef();
        const personEventStaffList = shallowRef();
        function openPersonEventStaffList() {
            personEventStaffList.value.openForm();
        }
        const eventStaffFunctions = ref([]);
        const eventStaffFunctionsConf = ref({});
        const { t } = useTranslation();
        const deleteStaff = ref(null);
        const headers = computed(() => [
            {
                text: t("events:staffRecruitment.eventStaffFunctions.table.column.name.label", "Function")
            },
            {
                text: t("events:staffRecruitment.eventStaffFunctions.table.column.role.label", "Role")
            },
            {
                text: t("events:staffRecruitment.eventStaffFunctions.table.column.description.label", "Description")
            },
            {
                text: t("events:staffRecruitment.eventStaffFunctions.table.column.profQualifications.label", "Requirements")
            },
            { text: "" }
        ]);
        const notPublic = computed(() => !eventStaffFunctionsConf.value.visibility ||
            eventStaffFunctionsConf.value.visibility == "admins");
        const groupedByStartDate = computed(() => {
            const days = calculateCompetitionDays(props.event.startDate, props.event.endDate);
            const groupedByDays = {};
            days.forEach(day => (groupedByDays[day] = []));
            eventStaffFunctions.value.forEach(c => {
                if (!groupedByDays[c.startDate])
                    groupedByDays[c.startDate] = [];
                groupedByDays[c.startDate].push(c);
            });
            return Object.entries(groupedByDays);
        });
        const viewablePersonStaffFunctions = computed(() => {
            return (
            // needs to be strictly false. null means no permission
            eventStaffFunctionsConf.value?.personEventStaffFunctionsUnlisted ===
                false ||
                allowedMutation(props.event.allowedFields, "personEventStaffFunctions"));
        });
        const { onResult, loading } = useQuery(gql `
    query eventStaffFunctions($eventId: ID) {
      event(id: $eventId) {
        id
        ${AppShowEventStaffFunctionConfStatusChip.fragments.eventFields}
        eventStaffFunctionsConf {
          ${EventStaffFunctionConfForm.fragments.eventStaffFunctionConfFields}
          ${AppShowEventStaffFunctionConfStatusChip.fragments.confFields}
          allowedMutations
        }
        eventStaffFunctions {
          id
          startDate
          name
          roleId
          role @client {
            id
            name
          }
          description
          profQualificationIds
          profQualifications @client {
            id
            name
          }
          regionIds
          regions @client {
            id
            name
          }
          allowedMutations
        }
      }
    }
  `, () => ({
            eventId: props.event.id
        }));
        onResult(({ loading, data }) => {
            if (loading)
                return;
            eventStaffFunctionsConf.value = data.event.eventStaffFunctionsConf ?? {};
            const compare = new Intl.Collator(appFederation.language, {
                sensitivity: "base"
            }).compare;
            eventStaffFunctions.value = cloneDeep(data.event?.eventStaffFunctions ?? []).sort((a, b) => compare(a.name, b.name));
        });
        function profQualificationsList(profs) {
            if (profs.length == 0)
                return "-";
            return profs?.map(x => x.name).join(", ") ?? "-";
        }
        function openForm(day, staff = null) {
            functionForm.value.openForm(day, staff);
        }
        function openConfForm() {
            functionConfigurationForm.value.openForm(eventStaffFunctionsConf.value);
        }
        async function deleteFunctionStaff(staff, evt) {
            deleteStaff.value = staff;
            const response = await confirm.value.blankSlateOpen();
            if (!response)
                return;
            const removeLoading = showLoadingButton(evt.target);
            try {
                await apolloClient.mutate({
                    mutation: gql `
        mutation eventStaffFunctionDelete($id: ID!) {
          eventStaffFunctionDelete(input: { id: $id }) {
            eventStaffFunction {
              id
            }
          }
        }
      `,
                    variables: {
                        id: staff.id
                    },
                    refetchQueries: ["eventStaffFunctions"]
                });
            }
            catch (error) {
                snackbarServerError(error, { level: "error" });
            }
            finally {
                removeLoading();
            }
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_btn_icon = _resolveComponent("v-btn-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(notPublic.value ? 'function-conf-private' : undefined)
                }, null, 2),
                (eventStaffFunctionsConf.value.publicNote)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["d-flex flex-row pa-4 eventStaffFunctionAlert", {
                                    'mb-2': !!eventStaffFunctionsConf.value.internalNote
                                }])
                        }, [
                            _createVNode(_component_v_icon, {
                                color: "red",
                                style: { "font-size": "20px" },
                                class: "pr-3"
                            }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode("$iconBell", -1)
                                ])),
                                _: 1,
                                __: [1]
                            }),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(eventStaffFunctionsConf.value.publicNote), 1)
                        ], 2)
                    ]))
                    : _createCommentVNode("", true),
                (eventStaffFunctionsConf.value.internalNote)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_v_icon, {
                            color: "black",
                            style: { "font-size": "20px" },
                            class: "pr-3"
                        }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("$iconEyeSlash", -1)
                            ])),
                            _: 1,
                            __: [2]
                        }),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(eventStaffFunctionsConf.value.internalNote), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(notPublic.value ? 'function-conf-private-contents' : undefined)
                }, [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6",
                                class: "d-flex align-md-center flex-column flex-md-row"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.heading", "Event staff functions")), 1),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(AppShowEventStaffFunctionConfStatusChip, {
                                            conf: eventStaffFunctionsConf.value,
                                            event: __props.event,
                                            class: _normalizeClass({ 'ml-4': _ctx.$vuetify.display.mdAndUp })
                                        }, null, 8, ["conf", "event", "class"])
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6",
                                class: "text-center text-md-end"
                            }, {
                                default: _withCtx(() => [
                                    (_unref(canManageEventStaffFunctionsConf)(__props.event, eventStaffFunctionsConf.value))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "ma-2",
                                            "data-test": "managePlanning",
                                            color: "edit",
                                            onClick: openConfForm
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("events:eventProfilePage.eventStaffFunctionsConf.managePlanning.label", "Manage planning")), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (_ctx.$allowedMutation(__props.event.allowedMutations, 'personEventStaffFunctionsCreateOrUpdate'))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            color: "accent",
                                            "data-test": "registerStaff",
                                            class: "ma-2",
                                            to: {
                                                name: 'EventPersonStaffCandidacyForm',
                                                params: { eventId: __props.event.id }
                                            }
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("events:staffPositionsApplications.candidate.button", "Apply")), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["to"]))
                                        : _createCommentVNode("", true),
                                    (viewablePersonStaffFunctions.value)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 2,
                                            color: "edit",
                                            "data-test": "candidatesListDialog",
                                            variant: "outlined",
                                            class: "ma-2",
                                            onClick: _cache[0] || (_cache[0] = () => openPersonEventStaffList())
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("events:personEventStaffFunctionsList.button", "Show list of candidate")), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (_ctx.$allowedMutation(__props.event.allowedFields, 'personEventStaffFunctions'))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 3,
                                            color: "edit",
                                            "data-test": "candidatesList",
                                            class: "ma-2",
                                            to: {
                                                name: 'PersonEventStaffFunctionsList',
                                                params: {
                                                    eventId: __props.event.id
                                                }
                                            }
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.manageCandidates.button", "Candidates")), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["to"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByStartDate.value, ([day, staffs]) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: day }, [
                            _createVNode(AppTableHeader, null, {
                                left: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$dayjs.date(day)), 1)
                                ]),
                                right: _withCtx(() => [
                                    (_ctx.$allowedMutation(__props.event.allowedMutations, 'eventStaffFunctionCreate'))
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "btn-with-icon mx-2 px-0 text-white",
                                            variant: "text",
                                            "min-width": "4px",
                                            "data-test": "addNewStaffFunction",
                                            onClick: () => openForm(day, null)
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                            _createTextVNode("$iconPlus", -1)
                                                        ])),
                                                        _: 1,
                                                        __: [3]
                                                    })
                                                ]),
                                                _createTextVNode("   " + _toDisplayString(_ctx.$t("common:button.add", "Add")), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(AppTable, {
                                items: staffs,
                                headers: headers.value,
                                loading: _unref(loading),
                                class: "mb-10",
                                "hide-headers": !_ctx.$vuetify.display.mdAndUp
                            }, {
                                items: _withCtx(() => [
                                    (_ctx.$vuetify.display.mdAndUp)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(staffs, (staff) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: staff.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", null, _toDisplayString(staff.name), 1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    (staff.roleId)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(_toDisplayString(staff.role.name), 1)
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", null, _toDisplayString(staff.description), 1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    (profQualificationsList(staff.profQualifications) ||
                                                        staff.regions?.length)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(_toDisplayString(profQualificationsList(staff.profQualifications)) + " ", 1),
                                                            (staff.regions?.length)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.table.representingRegionRequirement.label", "Person should represent one of the following regions:")), 1),
                                                                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                                                    _createTextVNode(" " + _toDisplayString(staff.regions.map(x => x.name).join(", ")), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode("-")
                                                        ], 64))
                                                ]),
                                                _createElementVNode("td", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, [
                                                        (_ctx.$allowedMutation(staff.allowedMutations, 'eventStaffFunctionUpdate'))
                                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                key: 0,
                                                                icon: "",
                                                                color: "edit-green",
                                                                "data-test": "updateStaffFunction",
                                                                size: "small",
                                                                class: "ma-2",
                                                                onClick: () => openForm(day, staff)
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                                            _createTextVNode("$edit", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [5]
                                                                    })
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true),
                                                        (_ctx.$allowedMutation(staff.allowedMutations, 'eventStaffFunctionDelete'))
                                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                key: 1,
                                                                icon: "",
                                                                color: "remove",
                                                                size: "small",
                                                                "data-test": "removeStaffFunction",
                                                                class: "ma-2",
                                                                onClick: evt => deleteFunctionStaff(staff, evt)
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                                            _createTextVNode("$iconTrash", -1)
                                                                        ])),
                                                                        _: 1,
                                                                        __: [6]
                                                                    })
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(staffs, (staff) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: staff.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.table.column.name.label", "Function")), 1),
                                                            _createTextVNode(" " + _toDisplayString(staff.name), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.table.column.description.label", "Description")), 1)
                                                        ]),
                                                        _createElementVNode("small", null, _toDisplayString(staff.description), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.table.column.profQualifications.label", "Requirements")), 1)
                                                        ]),
                                                        (profQualificationsList(staff.profQualifications) ||
                                                            staff.regions?.length)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(profQualificationsList(staff.profQualifications)) + " ", 1),
                                                                (staff.regions?.length)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        class: _normalizeClass({
                                                                            'mt-2': !!profQualificationsList(staff.profQualifications)
                                                                        })
                                                                    }, [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.table.representingRegionRequirement.label", "Person should represent one of the following regions:")), 1),
                                                                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                                                        _createTextVNode(" " + _toDisplayString(staff.regions.map(x => x.name).join(", ")), 1)
                                                                    ], 2))
                                                                    : _createCommentVNode("", true)
                                                            ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode("-")
                                                            ], 64))
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_13, [
                                                    _createVNode(AppButtonPositionSlot, null, {
                                                        default: _withCtx(() => [
                                                            (_ctx.$allowedMutation(staff.allowedMutations, 'eventStaffFunctionUpdate'))
                                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                    key: 0,
                                                                    icon: "",
                                                                    size: "small",
                                                                    color: "edit-green",
                                                                    class: "ma-2",
                                                                    onClick: () => openForm(day, staff)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { size: "small" }, {
                                                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                                _createTextVNode("$edit", -1)
                                                                            ])),
                                                                            _: 1,
                                                                            __: [8]
                                                                        })
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["onClick"]))
                                                                : _createCommentVNode("", true),
                                                            (_ctx.$allowedMutation(staff.allowedMutations, 'eventStaffFunctionDelete'))
                                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                    key: 1,
                                                                    icon: "",
                                                                    size: "small",
                                                                    color: "remove",
                                                                    class: "ma-2",
                                                                    onClick: evt => deleteFunctionStaff(staff, evt)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { size: "small" }, {
                                                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                                _createTextVNode("$iconTrash", -1)
                                                                            ])),
                                                                            _: 1,
                                                                            __: [9]
                                                                        })
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["onClick"]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ])
                                            ]));
                                        }), 128))
                                ]),
                                _: 2
                            }, 1032, ["items", "headers", "loading", "hide-headers"])
                        ], 64));
                    }), 128)),
                    (viewablePersonStaffFunctions.value)
                        ? (_openBlock(), _createBlock(PersonEventStaffListDialog, {
                            key: 0,
                            ref_key: "personEventStaffList",
                            ref: personEventStaffList,
                            "event-ids": [__props.event.id]
                        }, null, 8, ["event-ids"]))
                        : _createCommentVNode("", true),
                    _createVNode(EventStaffFunctionForm, {
                        ref_key: "functionForm",
                        ref: functionForm,
                        event: __props.event
                    }, null, 8, ["event"]),
                    _createVNode(EventStaffFunctionConfForm, {
                        ref_key: "functionConfigurationForm",
                        ref: functionConfigurationForm,
                        event: __props.event,
                        "event-staff-functions-conf": eventStaffFunctionsConf.value
                    }, null, 8, ["event", "event-staff-functions-conf"]),
                    _createVNode(AppConfirm, {
                        ref_key: "confirm",
                        ref: confirm
                    }, {
                        header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.delete.confirmTitle", "Delete staff function from planning and recruitment")), 1)
                        ]),
                        default: _withCtx(() => [
                            (deleteStaff.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("b", null, _toDisplayString(deleteStaff.value.name), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t("events:staffRecruitment.eventStaffFunctions.delete.confirmTitle", "You are going to delete the staff function from planning and recruitment. Are you sure?")), 1)
                        ]),
                        _: 1
                    }, 512)
                ], 2)
            ]));
        };
    }
});
